var _circle, _line, _line2, _ellipse, _ellipse2, _line3, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmotionBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 371,
    viewBox: "0 0 290 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.833,
    cy: 144.833,
    r: 144.833,
    fill: "url(#paint0_radial_1486_9817)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66.9375,
    y1: 103.281,
    x2: 115.562,
    y2: 103.281,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 172.047,
    y1: 103.281,
    x2: 220.672,
    y2: 103.281,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.789,
    cy: 113.252,
    rx: 8.47656,
    ry: 10.7363,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.398,
    cy: 113.252,
    rx: 8.47656,
    ry: 10.7363,
    fill: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 151.059,
    y1: 190.403,
    x2: 198.895,
    y2: 190.1,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.7021 333.643H101.558V319.106H105.811V356.431H90.4492V319.106H94.7021V333.643ZM101.558 352.305V337.578H94.7021V352.305H101.558ZM114.57 333.643H121.299V319.106H125.425V356.431H110.317V319.106H114.57V333.643ZM121.299 352.305V337.578H114.57V352.305H121.299ZM136.406 370.142H131.646V313.711H136.406V370.142ZM164.463 325.2C164.463 328.416 163.775 331.442 162.4 334.277C161.025 337.113 159.12 339.556 156.687 341.609C154.254 343.661 151.471 345.216 148.34 346.274L145.928 342.402C148.721 341.471 151.207 340.138 153.386 338.403C155.566 336.668 157.269 334.658 158.496 332.373C159.723 330.088 160.337 327.697 160.337 325.2V322.788H164.463V325.2ZM165.288 325.2C165.288 327.528 165.912 329.76 167.161 331.897C168.409 334.034 170.144 335.907 172.366 337.515C174.587 339.123 177.095 340.329 179.888 341.133L177.539 345.068C174.365 344.095 171.541 342.646 169.065 340.72C166.589 338.795 164.664 336.488 163.289 333.801C161.913 331.114 161.226 328.247 161.226 325.2V322.788H165.288V325.2ZM178.237 324.438H147.324V320.439H178.237V324.438ZM165.352 322.28H160.337V313.457H165.352V322.28ZM191.377 347.227H186.426V313.774H191.377V347.227ZM191.377 369.38H154.688V350.083H191.377V369.38ZM159.575 365.317H186.489V354.146H159.575V365.317Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.031 168.621C139.996 175.11 159.188 193.817 156.237 216.735",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1486_9817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.833 144.833) rotate(90) scale(144.833)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#FFB1B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBDC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmotionBad);
export default __webpack_public_path__ + "static/media/IconEmotionBad.137ad67d47aa358c7c0ec63ae9b10bcb.svg";
export { ForwardRef as ReactComponent };